class InteractiveSVG {
  constructor(config = {}) {
    this.container = document.querySelector('.ns-interactive-svg');
    if(!!this.container){
      this.targets = this.container.querySelectorAll('.ns-interactive-content');
      this.popup = document.createElement('div');
      this.popup.classList.add('ns-interactive-svg__popup');
      this.popupClose = document.createElement('button');
      this.popupClose.classList.add('ns-interactive-svg__popup-close');
      this.mobileSVG = this.container.querySelector('.interactive-svg__svg--mobile');
      this.desktopSVG = this.container.querySelector('.interactive-svg__svg--desktop');
      this.bindEvents(this.mobileSVG);
      this.bindEvents(this.desktopSVG);
    }
  }

  bindEvents(container){
    let events = container.querySelectorAll('#Events > g');
    let i = 0;
    events = Array.prototype.slice.call(events);
    events.reverse().forEach(element => {
      element.id = i;
      element.style.cursor = "pointer";
      element.addEventListener('click', (e) => {
        this.showTarget(element);
      });
      i++;
    });

    this.popupClose.addEventListener('click', () => {
      this.popup.style.display = 'none';
    });
  }

  showTarget(element){
    if(!!this.targets[element.id]){
      var rectElement = element.getBoundingClientRect();
      let rectContainer = this.container.getBoundingClientRect();
      this.popup.style.top = this.getRealOffsetTop(element);
      if(window.innerWidth >= 768){
        this.popup.style.left = rectElement.left - rectContainer.left + rectElement.width / 2 + 'px';
      } else{
        this.popup.style.left = "100px";
      }
      
      
      this.popup.style.display = "block";
      this.container.appendChild(this.popup);
      this.popup.innerHTML = this.targets[element.id].innerHTML;
      const img = this.popup.querySelector('img');
      if(!!img){
        img.src = img.dataset.src;
        img.classList.remove('lazy');
      }
      this.popup.prepend(this.popupClose);
    } else{
      alert("Fuer diesen Punkt gibt es leider keinen Inhalt.")
    }
  }

  getRealOffsetTop(elem) {
    const svg = this.container.querySelector('svg');
    const svgViewboxheight = svg.getAttribute('viewBox').split(' ').slice(-1); //getHeightOfViewbox
    const containerHeight = this.container.clientHeight;
    const circle = elem.querySelector('circle');
    return (parseInt(circle.getAttribute('cy')) / svgViewboxheight * containerHeight) + 'px';
  }



} export default InteractiveSVG;
